export const  AuthRoutes = {
   
    login: "/auth/admin/login",
    
    
  };
    